import BoxImage from "@components/BoxImage";
import BoxVideoThumbnail from "@components/BoxVideoThumbnail";
import { ICreateMediaItem } from "@interfaces/createMediaItem";
import { FormApi } from "final-form";
import { useEffect, useState } from "react";
import { TCreateMediaDto } from "types/Media/createMediaDto";
import styles from "./GalleryPreview.module.scss";

interface IGalleryPreviewProps {
  data: TCreateMediaDto;
  form: FormApi<Record<string, any>, Partial<Record<string, any>>>;
}

const GalleryPreview = ({ data, form }: IGalleryPreviewProps) => {
  const [previewImages, setPreviewImages] = useState<
    ICreateMediaItem[] | undefined
  >(data?.gallery);
  const [itemsForDelete, setItemsForDelete] = useState<ICreateMediaItem[]>([]);

  const handleOnRemove = (itemToRemove: ICreateMediaItem) => {
    setPreviewImages((prevState) =>
      prevState?.filter((item) => item !== itemToRemove)
    );
    setItemsForDelete((prevState) => [
      ...prevState,
      { mediaUrl: itemToRemove.mediaUrl, uuid: itemToRemove.uuid },
    ]);
  };

  useEffect(() => {
    // Add items to delete to the field to be used during update

    form.change("galleryFilesForDelete", itemsForDelete);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsForDelete]);

  return (
    <div>
      <div className={styles.gallery}>
        {previewImages &&
          previewImages.map((item) =>
            item.mediaUrl.includes("mp4") ? (
              <BoxVideoThumbnail
                url={item.mediaUrl}
                onRemove={() => handleOnRemove(item)}
              />
            ) : (
              <BoxImage
                urlImage={item.mediaUrl}
                isPreview
                onRemove={() => handleOnRemove(item)}
                key={item.uuid}
              />
            )
          )}
      </div>
    </div>
  );
};

export default GalleryPreview;
